var options = window.themeVariables.optionsLSP;
var lang = window.themeVariables.langLSP;
var lspSheetStorageVersion = "lspDataSheet-v" + options.sheetStorageVersion;
// Refetch the sheet after 1 hour so sheet edits reach returning visitors
var lspSheetMaxAge = 60 * 60 * 1000;

csvFetchLSP();

async function csvFetchLSP() {
            //Rely on shop switch for location
            async function getIpCountryCode() {
                const maxAttempts = 4;
                const delayBetweenAttempts = 500; // 500ms delay

                return new Promise((resolve, reject) => {
                    const attemptRequest = (attempt) => {
                        try {

                            // Only check market selection if multiple markets are enabled
                            if (options.shopifyMultipleMarketsEnabled) {
                                // Check if we have a non-primary market with a country code
                                if (!options.shopifyMarketSelectedIsPrimary && options.shopifyMarketSelectedCountryCode) {
                                    // Store the market selection in localStorage
                                    const marketData = {
                                        country_code: options.shopifyMarketSelectedCountryCode
                                    };
                                    localStorage.setItem('lspmarketcountrycode', JSON.stringify(marketData));
                                    resolve(options.shopifyMarketSelectedCountryCode);
                                    return;
                                }

                                // Try to get location from localStorage
                                const lspmarketcountrycode = localStorage.getItem('lspmarketcountrycode');

                                if (lspmarketcountrycode && !options.shopifyMarketSelectedIsPrimary) {
                                    const locationData = JSON.parse(lspmarketcountrycode);
                                    resolve(locationData.country_code);
                                    return;
                                }
                            }

                            // Fallback to geodata from shop switch
                            try {
                                const locationDataLocalStorage = JSON.parse(localStorage.getItem('geodata'));

                                if (!locationDataLocalStorage || !locationDataLocalStorage.country_code) {
                                    throw new Error('Invalid geodata');
                                }

                                const shopSwitchIpLocation = locationDataLocalStorage.country_code;

                                // Only store in lspmarketcountrycode if multiple markets enabled
                                if (options.shopifyMultipleMarketsEnabled) {
                                    const lspLocationData = {
                                        country_code: shopSwitchIpLocation
                                    };
                                    localStorage.setItem('lspmarketcountrycode', JSON.stringify(lspLocationData));
                                }

                                resolve(shopSwitchIpLocation);
                            } catch (error) {
                                console.error('Error processing geodata:', error);
                                if (attempt === maxAttempts) {
                                    // If it's the last attempt, try fetching the response from the API
                                    var url = "https://api.ipstack.com/check?access_key=" + options.ipstackAPIKey;
                                    fetch(url)
                                        .then(response => {
                                            if (!response.ok) throw new Error("Failed to fetch");
                                            return response.json();
                                        })
                                        .then(data => {
                                            window.ipstack = data;
                                            localStorage.setItem('geodata', JSON.stringify(window.ipstack));
                                            // Only store in lspmarketcountrycode if multiple markets enabled
                                            if (options.shopifyMultipleMarketsEnabled) {
                                                localStorage.setItem('lspmarketcountrycode', JSON.stringify({
                                                    country_code: data.country_code
                                                }));
                                            }
                                            resolve(window.ipstack.country_code);
                                        })
                                        .catch(() => {
                                            // If the API call fails, resolve with "DEFAULT"
                                            resolve("DEFAULT");
                                        });
                                } else {
                                    // Make the next attempt after the delay
                                    setTimeout(() => {
                                        attemptRequest(attempt + 1);
                                    }, delayBetweenAttempts);
                                }
                            }
                        } catch (error) {
                            if (attempt === maxAttempts) {
                                // If it's the last attempt, try fetching the response from the API
                                var url = "https://api.ipstack.com/check?access_key=" + options.ipstackAPIKey;
                                fetch(url)
                                    .then(response => {
                                        if (!response.ok) throw new Error("Failed to fetch");
                                        return response.json();
                                    })
                                    .then(data => {
                                        window.ipstack = data;
                                        localStorage.setItem('geodata', JSON.stringify(window.ipstack));
                                        // Only store in lspmarketcountrycode if multiple markets enabled
                                        if (options.shopifyMultipleMarketsEnabled) {
                                            localStorage.setItem('lspmarketcountrycode', JSON.stringify({
                                                country_code: data.country_code
                                            }));
                                        }
                                        resolve(window.ipstack.country_code);
                                    })
                                    .catch(() => {
                                        // If the API call fails, resolve with "DEFAULT"
                                        resolve("DEFAULT");
                                    });
                            } else {
                                // Make the next attempt after the delay
                                setTimeout(() => {
                                    attemptRequest(attempt + 1);
                                }, delayBetweenAttempts);
                            }
                        }
                    };

                    // Start the first attempt
                    attemptRequest(1);
                });
            }
            //Getting local stored LSP data
            function lspStoredDataGet() {
                return new Promise(resolve => {
                    resolve(JSON.parse(localStorage.getItem(lspSheetStorageVersion)));
                });
            }
            var lspStoredData = await lspStoredDataGet();
            var locationData = await getIpCountryCode();
            //Set to false for local storage debugging
            //var lspStoredData = false;
            //Stored data without fetchedAt was saved before the expiry existed, so it counts as expired
            var lspStoredDataFresh = lspStoredData && lspStoredData.fetchedAt && (Date.now() - lspStoredData.fetchedAt < lspSheetMaxAge);
            if(lspStoredDataFresh) {
                var data = lspStoredData;
                getCountryData(locationData,data);
            } else if (locationData) {
                const sheetURL = options.sheetUrl;
                const sheetName = options.sheetName;
                const sheetAPIKey = options.sheetAPIKey;
                if (sheetURL && sheetName && sheetAPIKey) {
                    const fetchUrl = 'https://sheets.googleapis.com/v4/spreadsheets/' +
                            options.sheetUrl + '/values/' + options.sheetName +
                            '?alt=json&key=' + options.sheetAPIKey;
                    $.ajax({url: fetchUrl, type: 'GET', dataType: 'json'})
                    .done(function(data) {
                        // Start render when we have response from Sheets
                        if (locationData && data) {
                            getCountryData(locationData,data);
                            data.fetchedAt = Date.now();
                            localStorage.setItem(lspSheetStorageVersion, JSON.stringify(data));

                            // Array for old local storage LSPs
                            var lspOldStorageArr = [];

                            // Iterate over localStorage and insert the keys that meet the condition into lspOldStorageArr
                            for (var i = 0; i < localStorage.length; i++){
                                const lspStorageInstance = localStorage.key(i).split('DataSheet-v');
                                const lspStorageInstancePrefix = lspStorageInstance.shift();
                                if (localStorage.key(i) === lspSheetStorageVersion) {
                                    //Keep newest local storage
                                } else if (lspStorageInstancePrefix === 'lsp') {
                                    lspOldStorageArr.push(localStorage.key(i));
                                }
                            }

                            // Iterate over lspOldStorageArr and remove the items by key
                            for (var i = 0; i < lspOldStorageArr.length; i++) {
                                localStorage.removeItem(lspOldStorageArr[i]);
                            }
                        }
                    })
                    .fail((e) => {
                        console.log(e.status);
                        //Render the expired copy rather than nothing
                        if (lspStoredData) {
                            getCountryData(locationData,lspStoredData);
                        }
                    });
                }
            } else if (lspStoredData) {
                getCountryData(locationData,lspStoredData);
            }
};




      // Rendering and prettying data
      var renderDataLSP = function (currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData) {
        // Constructing data for display

        showShippingInfo(currentCountryActiveData);
        showCountrySelector(currentCountryActiveData);

        // Initialize cart drawer shipping info updates
        updateCartDrawerShippingInfo(currentCountryActiveData);

        //Get cart on page load and taking action
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cart => {
            insertUSPData(cart, currentCountryActiveData, currentCountryActiveUspData, uspFallbackTextData);
            updateShippingProgress(cart, currentCountryActiveData, currentCountryActiveUspData);
          })
          .catch(error => console.error('Error fetching cart:', error));

        //updating cart drawer based on cart elements - cart JSON cart not needed
        updateCartPriceAndShipping(currentCountryActiveData,currentCountryActiveUspData);

        //Listener to cart action
        startCurrentCartListener(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData);

      }


      function insertUSPData(currentCart,currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData) {
        let currentCountryShippingPrice = "";
        let currentCountryDeliveryTime = "";
        let currentCountryFreeShippingThreshold = "";
        var minOrderAmount = "";
        var currentCountryName = "";

        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyShippingProduct = false;
        let isHeavyDeliveryTimeProduct = false;
        let isHeavyThresholdProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.DeliveryTimeHeavy) {
                isHeavyDeliveryTimeProduct = true;
            }
            if(currentCountryActiveData.ShippingPriceHeavy) {
                isHeavyShippingProduct = true;
            }
            if(currentCountryActiveData.FreeShippingThresholdHeavy) {
                isHeavyThresholdProduct = true;
            }
        }
        //heavy product in cart
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyDeliveryTimeProduct = true;
            isHeavyShippingProduct = true;
            isHeavyThresholdProduct = true;
        }
        currentCountryDeliveryTime = isHeavyDeliveryTimeProduct ? currentCountryActiveData.DeliveryTimeHeavy:currentCountryActiveData.DeliveryTime;
        currentCountryShippingPrice = isHeavyShippingProduct ? currentCountryActiveData.ShippingPriceHeavy:currentCountryActiveData.ShippingPrice;
        currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;
        if(currentCountryFreeShippingThreshold) {
            currentCountryFreeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
        }

        //Delivery time with days
        if (currentCountryDeliveryTime) {
            currentCountryDeliveryTime = currentCountryDeliveryTime + " " + lang.days;
        }
        //FreeShippingThreshold = minimum order amount
        if(currentCountryFreeShippingThreshold) {
            minOrderAmount = slateCurrency.formatMoney(currentCountryFreeShippingThreshold * 100, window.themeVariables.settings.moneyFormat, true);
        }
        //Active country name
        if (currentCountryActiveData.Country) {
            currentCountryName = currentCountryActiveData.Country
        }
        //Active shipping price
        if (currentCountryShippingPrice) {
            currentCountryShippingPrice = slateCurrency.formatMoney(currentCountryShippingPrice * 100, window.themeVariables.settings.moneyFormat, true);
        }

        $( ".lspList .lspListInner" ).each(function( index ) {
            var allUspMessageContent = "";

            // Don't remove skeleton items yet - we'll do it after content is ready

            //Make blank if threshhold is 0/heavy
            if(isHeavyShippingProduct && uspFallbackTextData) {
                const ArrayHasFallbackUSP = currentCountryActiveUspData.find(currentCountryActiveUspData =>currentCountryActiveUspData.includes(uspFallbackTextData));
                if(ArrayHasFallbackUSP) {

                } else {
                    currentCountryActiveUspData.push(uspFallbackTextData);
                }
            }
            for (var uspCount = 0; uspCount < currentCountryActiveUspData.length; uspCount++) {
                //Replacing amount with min order amount
                let formatedCurrentCountryActiveUspData = currentCountryActiveUspData[uspCount];
                if(formatedCurrentCountryActiveUspData) {
                    let isFallBackUSP = false;
                    if(formatedCurrentCountryActiveUspData === uspFallbackTextData) {
                        isFallBackUSP = true;
                    }
                    //Make blank if threshhold is 0/heavy
                    if(currentCountryFreeShippingThreshold === 0 && !isFallBackUSP) {
                        if(formatedCurrentCountryActiveUspData.includes("[amount]") || formatedCurrentCountryActiveUspData.includes("[time]")) {
                            formatedCurrentCountryActiveUspData = "";
                        }
                    } else if (isHeavyShippingProduct && isFallBackUSP){
                        //Insure USP with amount don't show up
                        if(currentCountryFreeShippingThreshold === 0) {
                            if(formatedCurrentCountryActiveUspData.includes("[amount]")) {
                                formatedCurrentCountryActiveUspData = "";
                            }
                        }
                    }

                    //Insure USP with hide-heavy gets excluded
                    if(isHeavyDeliveryTimeProduct && formatedCurrentCountryActiveUspData.includes("[hide-heavy]")) {
                        formatedCurrentCountryActiveUspData = "";
                    }
                    //FORMATING shortcodes

                    //Feature to come - shipping price
                    /*
                    if (formatedCurrentCountryActiveUspData.includes("[price]") && minOrderAmount ) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[price]", minOrderAmount);
                    }
                    */

                    //Replacing amount with min amount for deliver
                    if (formatedCurrentCountryActiveUspData.includes("[amount]") && minOrderAmount) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[amount]", `<span class="lspShortCodeAmount">${minOrderAmount}</span>`);
                    }

                    //Replacing time with delivery days
                    if (formatedCurrentCountryActiveUspData.includes("[time]") && currentCountryDeliveryTime) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[time]", `<span class="lspShortCodeTime">${currentCountryDeliveryTime}</span>`);
                    }

                    //Replacing country with country name
                    if (formatedCurrentCountryActiveUspData.includes("[country]") && currentCountryName) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[country]", `<span class="lspShortCodeCountry">${currentCountryName}</span>`);
                    }

                    //Replacing hide-heavy shortcode
                    if (formatedCurrentCountryActiveUspData.includes("[hide-heavy]") && currentCountryName) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[hide-heavy]", "");
                    }

                    //Replacing icon with icon from Shopify settings
                    var iconCount = "";
                    if (formatedCurrentCountryActiveUspData.includes("[icon")) {
                        iconCount = currentCountryActiveUspData[uspCount].split('[icon')
                        .filter(function(v){ return v.indexOf(']') > -1})
                        .map( function(value) {
                            iconCount = value.split(']')[0]
                            const currentUspIcon = "usp_icon_" + iconCount;
                            iconShortcode = "[icon" + iconCount + "]";
                            if (currentCountryActiveData.USPIcons && currentCountryActiveData.USPIcons[currentUspIcon]) {
                                formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace(iconShortcode, currentCountryActiveData.USPIcons[currentUspIcon]);
                            } else {
                                formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace(iconShortcode, "");
                            }
                        })
                    }
                    if (formatedCurrentCountryActiveUspData) {
                        allUspMessageContent = allUspMessageContent + '<div class="lspListItem">' + formatedCurrentCountryActiveUspData + '</div>';
                    }
                }
            }

            // Only remove skeleton and insert content when we have all USPs ready
            if (allUspMessageContent) {
                // Remove skeleton items only when we have content
                $(this).find('.skeleton').remove();
                //HTML rendering
                $(this).html(allUspMessageContent);
            }

            if(currentCountryActiveData.EnabledCountry === "TRUE") {
                $(this).parent().addClass("skeletonShow");
            } else {
                $(this).parent().addClass("skeletonHidden");
            }
        });
    }
    function showCountrySelector(currentCountryActiveData) {
        //Active country name
        var currentCountryName = "";
        if (currentCountryActiveData.Country) {
            currentCountryName = currentCountryActiveData.Country
        }
        $( ".lspCountrySelect" ).each(function( index ) {
            $(this)[0].innerHTML = currentCountryName;
        });
    }
    function showShippingInfo(currentCountryActiveData) {
        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyDeliveryTimeProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.DeliveryTimeHeavy) {
                isHeavyDeliveryTimeProduct = true;
            }
        }
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyDeliveryTimeProduct = true;
        }
        let currentCountryDeliveryTime = isHeavyDeliveryTimeProduct ? currentCountryActiveData.DeliveryTimeHeavy:currentCountryActiveData.DeliveryTime;

        //Delivery time with days
        if (currentCountryDeliveryTime) {
            currentCountryDeliveryTime = currentCountryDeliveryTime + " " + lang.days;
        }
        $( ".lspShippingInfo" ).each(function( index ) {
            let deliveryTimeEl = $(this).find('.lspExpectedDeliveryTime')[0];
            if(deliveryTimeEl && currentCountryDeliveryTime) {
                deliveryTimeEl.innerHTML = currentCountryDeliveryTime;
                if(currentCountryActiveData.EnabledCountry === "TRUE") {
                    $(this).removeClass("skeletonHidden");
                    $(this).addClass("skeletonShow");
                }
            }
        });
    }
    function updateCartPriceAndShipping(currentCountryActiveData) {
        // Function to handle price updates
        const updatePrices = () => {
            let currentCountryShippingPrice = "";
            let currentCountryShippingPriceRaw = "";
            let currentCountryFreeShippingThreshold = "";

            let hasHeavyWeightCartItem = false;
            let isHeavyThresholdProduct = false;
            if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
                hasHeavyWeightCartItem = true;
                isHeavyThresholdProduct = true;
            }
            currentCountryShippingPriceRaw = hasHeavyWeightCartItem ? currentCountryActiveData.ShippingPriceHeavy:currentCountryActiveData.ShippingPrice;

            if (currentCountryShippingPriceRaw) {
                currentCountryShippingPrice = slateCurrency.formatMoney(currentCountryShippingPriceRaw * 100, window.themeVariables.settings.moneyFormat);
            }

            currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;

            $( ".CartTotalLSP" ).each(function( index ) {
                var currentCountryName = "";
                //Active country name
                if (currentCountryActiveData.Country) {
                    currentCountryName = currentCountryActiveData.Country
                }
                let cartShippingPriceEl = $(this).find('.Cart__ShippingPrice');
                let cartShippingPriceTitleEl = $(this).find('.Cart__Shipping [data-shipping-title]')[0];
                if(cartShippingPriceTitleEl) {
                    let cartShippingPriceTitle = cartShippingPriceTitleEl.innerHTML;
                    if(cartShippingPriceTitleEl && cartShippingPriceTitle.includes("[country]") && currentCountryName) {
                        cartShippingPriceTitle = cartShippingPriceTitle.replace("[country]", currentCountryName);
                        cartShippingPriceTitleEl.innerHTML = cartShippingPriceTitle;
                    }
                }
                const cartTotalPriceEl = $(this).find('.Cart__TotalPrice');
                const cartTotalPriceValue = $(this).find('.Cart__TotalPrice').attr('data-cart-total-price');


                var freeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
                if(freeShippingThreshold !== "" && Number(cartTotalPriceValue)) {

                        //Calculating percentage progress of free shipping
                        var thresholdInCents = freeShippingThreshold * 100;
                        var cartThresholdDifference = (Number(cartTotalPriceValue) / thresholdInCents) * 100;
                        var currentProgress = 0;
                        currentProgress = cartThresholdDifference;
                        if(Number(cartTotalPriceValue) == 0) {
                            currentProgress = 0;
                        } else if (currentProgress >= 100) {
                            currentProgress = 100;

                        }
                }


                if(cartTotalPriceEl && cartTotalPriceValue && currentCountryShippingPrice) {
                    const totalPriceWithShipping = Number(cartTotalPriceValue) + Number(currentCountryShippingPriceRaw * 100);
                    if(totalPriceWithShipping) {
                        const totalPriceWithShippingFormatPrice = slateCurrency.formatMoney(totalPriceWithShipping, window.themeVariables.settings.moneyFormat);
                        if (currentProgress < 100 || currentCountryFreeShippingThreshold === "0") {
                            cartTotalPriceEl.html(totalPriceWithShippingFormatPrice);
                            if (cartShippingPriceEl && currentCountryShippingPrice) {
                                cartShippingPriceEl.html(slateCurrency.formatMoney(currentCountryShippingPriceRaw * 100, window.themeVariables.settings.moneyFormat));
                            }
                        } else {
                            // When free shipping applies, we should still format the total price correctly
                            cartTotalPriceEl.html(slateCurrency.formatMoney(cartTotalPriceValue, window.themeVariables.settings.moneyFormat));
                            if(cartShippingPriceEl && currentCountryFreeShippingThreshold) {
                                cartShippingPriceEl.html(lang.freeShippingShort);
                            } else if (cartShippingPriceEl && currentCountryShippingPrice) {
                                cartShippingPriceEl.html(slateCurrency.formatMoney(currentCountryShippingPriceRaw * 100, window.themeVariables.settings.moneyFormat));
                            }
                        }
                    }

                }
                if(currentCountryActiveData.EnabledCountry === "TRUE") {
                    $(this).find('.Cart__Shipping').removeClass("skeletonHidden");
                    $(this).find('.Cart__Shipping').addClass("skeletonShow");
                }
            });
        };

        // Run immediately if we're on the cart page
        if (window.themeVariables.settings.pageType === "cart") {
            updatePrices();
        }

        // Maintain the event listener for dynamic updates
        document.addEventListener('cart-drawer:refreshed', updatePrices);
    }


    function updateShippingProgress(currentCart, currentCountryActiveData) {
        let currentCountryFreeShippingThreshold = "";

        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyThresholdProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.FreeShippingThresholdHeavy) {
                isHeavyThresholdProduct = true;
            }
        }
        //heavy product in cart
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyThresholdProduct = true;
        }
        currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;

        var freeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
        if(freeShippingThreshold !== "" && currentCart.total_price !== "") {
                var remainingAmount = (currentCart.total_price / 100) - freeShippingThreshold;
                var remainingAmountFormat = slateCurrency.formatMoney(remainingAmount * -1 * 100, window.themeVariables.settings.moneyFormat);
                //Calculating percentage progress of free shipping
                var thresholdInCents = freeShippingThreshold * 100;
                var cartThresholdDifference = (currentCart.total_price / thresholdInCents) * 100;
                var currentProgress = 0;
                currentProgress = cartThresholdDifference;
                if(currentCart.total_price == 0) {
                    currentProgress = 0;
                } else if (currentProgress >= 100) {
                    currentProgress = 100;
                }
                let progressAboveMinCartTotal = true;
                if (options.progressMinCartTotal) {
                    let progressMinCartTotal = options.progressMinCartTotal * 100;
                    if(currentCart.total_price < progressMinCartTotal) {
                        progressAboveMinCartTotal = false;
                    }
                }
                currentProgressWithPercentage = currentProgress + "%";
                //Applying progress to bar
                if(progressAboveMinCartTotal) {
                    $('.ProgressLSP').each(function() {
                        // Remove display:none first
                        $(this).css('display', '');

                        const progressBarElWrapper = $(this);
                        const progressBarEl = $(this).find('.ProgressBar__Active');
                        const progressBarShowing = progressBarElWrapper.hasClass('ProgressLSPShow');

                        if(freeShippingThreshold !== "" && freeShippingThreshold === 0) {
                            if(progressBarShowing) {
                                progressBarElWrapper.removeClass("ProgressLSPShow");
                            }
                        }else if(currentCart.total_price !== 0) {
                            if(!progressBarShowing) {
                                progressBarElWrapper.addClass("ProgressLSPShow");
                            }
                        }
                        //Applying progress to bar
                        if(progressBarEl) {
                            const targetAmountEl = $(this).find('.ProgressBar__TargetAmount');
                            const formattedTargetAmount = slateCurrency.formatMoney(freeShippingThreshold * 100, window.themeVariables.settings.moneyFormat);
                            targetAmountEl.html(formattedTargetAmount);

                            const progressBarTextEl = $(this).find('.ProgressLSPText');

                            let progressBarText = lang.freeShippingRemaining;
                            if(progressBarText.includes("{{remaining_amount}}") && currentProgress < 100) {
                                if (currentProgress < 100) {
                                    if (currentProgress < 50 && progressBarTextEl) {
                                        progressBarTextEl.css({
                                          'left': '0',
                                          'transform': 'none'
                                        });
                                    }
                                    progressBarText = progressBarText.replace('{{remaining_amount}}', remainingAmountFormat);
                                }
                            } else if (currentProgress >= 100) {
                                progressBarText = lang.freeShippingReached;
                            }
                            $(this).find('.ProgressLSPText').html(progressBarText);
                        }
                        if(currentCountryActiveData.EnabledCountry === "TRUE" && currentCountryFreeShippingThreshold !== "") {
                                // Remove inline display:none
                                $(this).css('display', '');
                                $(this).removeClass('skeletonHidden');
                                $(this).addClass('skeletonShow ProgressLSPShow');
                        }
                        setTimeout(() => {
                        if(progressBarEl) {
                            progressBarEl.css({
                                'width': currentProgressWithPercentage,
                                'transition': 'width 0.6s ease-in-out'
                            });
                        }
                        }, 700);
                    });
                }


        }
    }


      async function startCurrentCartListener(currentCountryActiveData, currentCountryActiveUspData, uspFallbackTextData) {
        // Listen for cart drawer opening
        document.addEventListener('cart-drawer:refreshed', () => {
            fetch(`${window.Shopify.routes.root}cart.js`)
              .then(response => response.json())
              .then(cart => {
                insertUSPData(cart, currentCountryActiveData, currentCountryActiveUspData, uspFallbackTextData);
                updateShippingProgress(cart, currentCountryActiveData, currentCountryActiveUspData);
              })
              .catch(error => console.error('Error fetching cart:', error));
        });

      }


      //Fetching country DATA
      var getCountryData = function (locationData,data) {
        const tableJSON = data.values;
        const keys = Object.keys(tableJSON[0]).map(i => tableJSON[0][i]);
        // JSON Country data
        let countryData = tableJSON.map(obj => {
            const replacedObj = {};
            const oriKeys = Object.keys(obj);
            for (let i = 0; i < keys.length; i++) {
                replacedObj[keys[i]] = obj[oriKeys[i]]
            };
            return replacedObj;
        });

        // JSON USP text data
        var uspAllTextData = [];
        var uspFallbackTextData = "";
        let uspTextDataCount = 0;
        let UPSIndex = null
        let uspData = tableJSON.map((obj,index) => {
            const replacedObj = {};
            const oriKeys = Object.keys(obj);
            if(index == 0){
                for (let j = 0; j < obj.length; j++) {
                    const element = obj[j];
                    if(element == "USP text"){
                        UPSIndex = j
                    }
                }
            }
            //Fallback for heavy item
            if(index === 11 && index !== 0 ){
                if(obj[UPSIndex]) {
                    uspFallbackTextData = obj[UPSIndex];
                 }
            } else if (obj[UPSIndex] && index !== 0 ){
                uspAllTextData.push(obj[UPSIndex]);
            }
        });
        //removing undefined
        //let prepaidObjectNew = JSON.parse(JSON.stringify(uspData))


        //Country seek

        //Fetch default country
        let fallbackCountry = countryData.filter(function(item){
            return item.CountryCode == "DEFAULT";
        });
        var fallbackCountryObj = fallbackCountry[Object.keys(fallbackCountry)[0]];

        //Fetch IP country
        var currentCountryCode = locationData;

        //Fetch current country
        let currentCountry = countryData.filter(function(item){
            return item.CountryCode == currentCountryCode;
        });
        var currentCountryObj = currentCountry[Object.keys(currentCountry)[0]];


        //Use default fallback if country is not found in Sheet
        if (currentCountryObj) {

        } else if (fallbackCountryObj) {
            currentCountryObj = fallbackCountryObj;
        } else {
        }

        //Sheet amounts are in the row's Currency (blank = EUR). If the IP country is priced in another currency
        //than the active market (e.g. Danish IP on the EUR store), use the market's own country instead
        var activeCurrency = window.Shopify && Shopify.currency && Shopify.currency.active;
        if (currentCountryObj && activeCurrency && (currentCountryObj["Currency"] || "EUR") !== activeCurrency) {
            let marketCountry = countryData.filter(function(item){
                return item.CountryCode == options.shopifyMarketSelectedCountryCode;
            });
            currentCountryObj = marketCountry[0] || fallbackCountryObj;
        }
        var currentCountryActiveData = {
            "EnabledCountry": currentCountryObj["Active"],
            "Country": currentCountryObj["Country"] || fallbackCountryObj["Country"],
            "DeliveryTime": currentCountryObj["Delivery time"] || fallbackCountryObj["Delivery time"],
            "DeliveryTimeHeavy": currentCountryObj["Delivery time heavy"] || fallbackCountryObj["Delivery time heavy"],
            "FreeShippingThreshold": (currentCountryObj["Free shipping threshold"] === "NONE" ? "" : currentCountryObj["Free shipping threshold"]) ||
                                    (fallbackCountryObj["Free shipping threshold"] === "NONE" ? "" : fallbackCountryObj["Free shipping threshold"]),
            "FreeShippingThresholdHeavy": (currentCountryObj["Free shipping threshold heavy"] === "NONE" ? "" : currentCountryObj["Free shipping threshold heavy"]) ||
                                         (fallbackCountryObj["Free shipping threshold heavy"] === "NONE" ? "" : fallbackCountryObj["Free shipping threshold heavy"]),
            "ShippingPrice": currentCountryObj["Shipping price"] || fallbackCountryObj["Shipping price"],
            "ShippingPriceHeavy": currentCountryObj["Shipping price heavy"] || fallbackCountryObj["Shipping price heavy"],
            "USPIcons": window.themeVariables.iconsLSP
        }


        //Render USP data
        var currentCountryActiveUspData = getCountryUspData(currentCountryObj,uspAllTextData,uspFallbackTextData);
        //Using fallback country if no USP data found for country
        if (currentCountryActiveUspData.length === 0) {
            currentCountryActiveUspData = getCountryUspData(fallbackCountryObj,uspAllTextData,uspFallbackTextData);
        }

        //Assign country name as default country name if data is blank
        /*
        if (currentCountryObj["Delivery time"] && currentCountryObj["Free shipping threshold"] && currentCountryObj["Shipping price"]) {
        } else {
            currentCountryActiveData.Country = fallbackCountryObj["Country"];
        }
        */

        //Saving country data found as localstorage
        // Render
        if(currentCountryActiveData.EnabledCountry === "TRUE") {
            renderDataLSP(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData);
        } else {
            renderDataLSP(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData);
            //unsupportedCountryWarning(currentCountryActiveData,currentCountryActiveUspData);
        }
      }

      var unsupportedCountryWarning = function (currentCountryActiveData,currentCountryActiveUspData) {

      }
      var getCountryUspData = function (currentCountryObj, uspAllTextData, uspFallbackTextData) {
        //Finding USP active states for country being parsed
        let currentCountryUspStatus = []
        const currentCountryUspMax = 10;
        let currentCountryUspCount = 0;


        // Check if we should use translated USPs
        //const shouldUseTranslatedUsps = options.shopifyMultipleMarketsEnabled &&
        //                              !options.shopifyMarketSelectedIsPrimary &&
        //                              options.shopifyMarketSelectedLanguage !== "en";
         const shouldUseTranslatedUsps = true;

        for (let i = 0; i < currentCountryUspMax; i++) {
            currentCountryUspCount = currentCountryUspCount + 1;
            let i = currentCountryUspCount;
            if(currentCountryObj["USP"+ `${currentCountryUspCount}`] !== "TRUE") {
                currentCountryUspStatus.push("FALSE")
            } else {
                currentCountryUspStatus.push(currentCountryObj["USP"+ `${currentCountryUspCount}`]);
            }
        }

        let currentCountryActiveUspData = []
        //mapping available USPS with active USPS
        for (var statusCount = 0; statusCount < currentCountryUspStatus.length; statusCount++) {
            if(currentCountryUspStatus[statusCount] === "TRUE") {
                for (var textCount = 0; textCount < uspAllTextData.length; textCount++) {
                    if (uspAllTextData[statusCount]) {
                        if (shouldUseTranslatedUsps) {
                            // Get the translated USP using the index (1-based)
                            const translatedUsp = lang["marketUsp" + (statusCount + 1)];

                            // Only use translation if it exists and isn't a missing translation
                            if (translatedUsp &&
                                translatedUsp.trim() !== "" &&
                                !translatedUsp.includes("Translation missing")) {
                                currentCountryActiveUspData.push(translatedUsp);
                            } else {
                                // Fallback to English USP if translation is invalid
                                currentCountryActiveUspData.push(uspAllTextData[statusCount]);
                            }
                        } else {
                            // Use original English USP
                            currentCountryActiveUspData.push(uspAllTextData[statusCount]);
                        }
                        break;
                    }
                }
            }
        }

        return currentCountryActiveUspData;
      }




//Libs for formatting money

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slateUtils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
      var i = array.length;
      while(i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }

      return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   */

  slateCurrency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format, useNoDecimals = false) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slateUtils.defaultTo(precision, 2);
        thousands = slateUtils.defaultTo(thousands, ',');
        decimal = slateUtils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      // ÆNDRING 1: match gemmes med fallback, så funktionen ikke kaster
      // en exception hvis formatet mangler en placeholder
      var placeholderMatch = formatString.match(placeholderRegex);
      var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

      if (useNoDecimals) {
        switch (placeholder) {
            case 'amount':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            // ÆNDRING 2: manglende Shopify-formater
            case 'amount_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ', ',');
              break;
            case 'amount_with_period_and_space_separator':
              value = formatWithDelimiters(cents, 0, ' ', '.');
              break;
            case 'amount_with_apostrophe_separator':
              value = formatWithDelimiters(cents, 0, "'", '.');
              break;
            // ÆNDRING 3: aldrig tomt igen
            default:
              value = formatWithDelimiters(cents, 0);
              break;
          }
      } else {
        switch (placeholder) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', ',');
            break;
          case 'amount_with_period_and_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
          default:
            value = formatWithDelimiters(cents, 2);
            break;
        }
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  })();


  /**
   * END Currency Helpers
   */

// Add this new function to initialize LSP on cart drawer open
function initializeLSPForCartDrawer() {
    document.addEventListener('cart-drawer:refreshed', () => {
        const progressLSP = document.querySelector('.ProgressLSP');
        if (progressLSP) {
            // Remove inline display:none
            progressLSP.css('display', '');
            progressLSP.removeClass('skeletonHidden');
            progressLSP.addClass('skeletonShow ProgressLSPShow');
        }
    });
}

// Add this new function to handle cart drawer shipping info updates
function updateCartDrawerShippingInfo(currentCountryActiveData) {
    document.addEventListener('cart-drawer:refreshed', () => {
        showShippingInfo(currentCountryActiveData);
    });
}


//Listening to any cart API change

/*
async function listenCartChange() {
    (function () {
    if (!window || !window.Shopify) return;

    const CartEvents = {
        add: "SCE:action",
        update: "SCE:action",
        change: "SCE:action",
        clear: "SCE:action",
        mutate: "SCE:action",
    };
    //For specfic event listening
    const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
    ];

    function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
    }

    function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
        return "add";
    } else if (url.includes("cart/update")) {
        return "update";
    } else if (url.includes("cart/change")) {
        return "change";
    } else if (url.includes("cart/clear")) {
        return "clear";
    } else return false;
    }

    function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
        try {
        detail = JSON.parse(detail);
        } catch {}
    }
    //Not needed duplicate
    //window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
        case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
        case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
        case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
        case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
        default:
        break;
    }
    }

    function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
        }
        });
        return originalOpen.apply(this, arguments);
    };
    }

    function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
        const response = originalFetch.apply(this, arguments);

        if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
            res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
        }

        return response;
    };
    }

    fetchOverride();
    XHROverride();
})();
}

    /*
    const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
    };
    */
